const initialAssignmentsFilterState = {
  fetching: false,
  fetched: false,
  items: [],
  error: null,
  nbResult: 0
};

export const getEventStatsDataTableReducer = (state = initialAssignmentsFilterState, action) => {
  switch (action.type) {
    case "GET_DATA_TABLE_EVENT_STATS_PENDING": {
      return {...state, fetched: false, fetching: true};
    }
    case "GET_DATA_TABLE_EVENT_STATS_FULFILLED": {
      const {data, nbResult} = action.payload.data;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: data ? data : [],
        nbResult: nbResult
      };
    }

    case "GET_DATA_TABLE_EVENT_STATS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        items: [],
        nbResult: 0,
        error
      };
    }



    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/index/EventStats/getEventStatsDataTableReducer.js